import React, {Fragment} from 'react'
import Select from "react-select";

class SelectBase extends Select {

    state = {
        outOptions: [],
        inOptions: [],
        selectedOptions: [],
        selectedAllChecked: false,
        isAllChecked: false,
        menuIsOpen: false,
        toggle: false,

        menuPlacement: "bottom",
        placement: "bottom",
    }

    select = React.createRef();

    menuPositionStartSelector = this.props.menuPositionStartSelector ?? '.select-position';

    filterButtons = Object.assign({done: true, cancel: false}, this.props.filterButtons);

    setMenuPosition = (select, menu) => {

        var menuParent, forceSelect, selectParent, selectPos, forceSelectPos, menuPos, menuTop, arrowTop;

        if(select) selectParent = select.closest(this.menuPositionStartSelector) ?? select;
        if(select) forceSelect = select.closest('.react-select') ?? select.closest(this.menuPositionStartSelector) ;
        if(menu) menuParent = menu.closest('.react-select-dropdown-menu') ?? menu;
        if(selectParent) selectPos = selectParent.getBoundingClientRect();
        if(forceSelect) forceSelectPos = forceSelect.getBoundingClientRect();
        if(menuParent) menuPos = menuParent.getBoundingClientRect();

        if(menuParent) {
            if(selectPos.top + menuPos.height > window.innerHeight) {
                menuTop = (selectPos.top + selectPos.height) - menuPos.height;
                menuTop = menuTop < 0 ? 0 : menuTop;
            } else {
                menuTop = selectPos.top;
            }
            arrowTop = forceSelectPos.top + 3;

            forceSelect.style.setProperty('--arrow-right-top', `${arrowTop}px`);
            menuParent.style.setProperty("top", `${menuTop}px`, "important");
            menuParent.style.setProperty("bottom", `unset`, "important");

            if(this.props.onMenuPosition) {
                this.props.onMenuPosition(selectPos, menuPos);
            }
        }
    }

    filterOptions = (candidate, input) => {
        if (input) {
            return candidate.value === this.state.inOptions[0].value;
        }
        return true;
    };

    setClasses = (props, className) => {
        const classes = ['react-select', className];

        if(props.className)
            classes.push(props.className);

        if(props.type)
            switch(props.type) {
                case 'lg': { classes.push('react-select-lg'); }; break;
                case 'md': { classes.push('react-select-md'); }; break;
                case 'sm': { classes.push('react-select-sm'); }; break;
            }

        if(props.color) {
            // white, flat, secondary
            classes.push(`react-select-${props.color}`);
        } else {
            classes.push(`react-select-white`);
        }

        if(this.state.isAllChecked)
            classes.push('react-select-all-selected')

        classes.push(this.arrowSidePlacement());

        classes.push(this.state.menuIsOpen ? "open" : "");

        return classes.join(' ');
    }

    arrowSidePlacement = () => {
        switch(this.props.arrowSidePlacement) {
            case 'left': { return "arrow-left" };break;
            case 'right': { return "arrow-right" };break;
        }
    }

    arrowAutoPlacement = (menuPlacement, placement) => {

        if(this.props.arrowSidePlacement) {
            return null;
        }

        switch(menuPlacement) {
            case 'top': { return "arrow-down" };break;
            case 'bottom': { return "arrow-up" };break;
            case 'auto': { return placement == 'top' ? "arrow-down" : "arrow-up" };break;
        }
    }

    onCheckChange = (option) => {

        // copy options
        var defaultOptions = this.props.options;
        var outOptions = this.state.outOptions;
        var inOptions = this.state.inOptions;
        var allChecked = option.value == 'all' && option.checked;

        if(allChecked) {

            // if user made click check on all check

            outOptions = defaultOptions.map((item, key) => {
                return { ...item, checked: true };
            }).filter((item, key) => {
                return item.value != 'all';
            })

            // in section
            inOptions = inOptions.map((item, key) => {
                return { ...item, checked: true };
            })

        } else {

            // if user made click check on any check and not all

            if(this.state.isAllChecked) {
                outOptions = [];

                // in section
                inOptions = inOptions.map((item, key) => {
                    return { ...item, checked: false };
                })
            }

            // remove option from state
            outOptions = outOptions.filter((item, key) => {
                return item.key != option.key;
            });
            // add option to state
            if(option.checked && option.value != 'all')
                outOptions.push(option);

            // in section
            inOptions = inOptions.map((item, key) => {
                if(item.key === option.key)
                    return { ...item, checked: option.checked };
                else
                    return item;
            })
        }

        this.setState({
            isAllChecked: allChecked,
            outOptions: outOptions,
            inOptions: inOptions
        });

        if(this.props.onCheckChange)
            this.props.onCheckChange({
                option: option,
            });
    }

    onMenuOpen  = () => {

        if(this.props.onMenuOpen)
            this.props.onMenuOpen();

        var outOptions =
            this.props.selected
                ? this.state.selectedOptions.length > 0
                    ? this.state.selectedOptions.filter((item, key) => {
                        return item.value != 'all' && item.checked == true;
                      })
                    : []
                : [];

        var inOptions = this.props.options.map((item, key) => {
            return { ...item, checked:
                    this.props.selected
                        ? this.state.selectedOptions.length > 0 ? this.state.selectedOptions[key].checked : false
                        : false
            };
        });

        this.setState({
            outOptions: outOptions,
            inOptions: inOptions,
            isAllChecked: this.props.selected ? this.state.selectedAllChecked : false,
            menuIsOpen: true
        })
    }

    onMenuClose = () => {

        if(this.props.onMenuClose)
            this.props.onMenuClose();

        // clear state
        this.setState({
            outOptions: [],
            inOptions: [],
            isAllChecked: false,
            menuIsOpen: false,
        });
    }

    onDoneClick = (e) => {

        e.preventDefault();

        var {inOptions, isAllChecked} = this.state;

        this.setState({
            // reset
            outOptions: [],
            inOptions: [],
            isAllChecked: false,
            // selected
            selectedOptions: inOptions,
            selectedAllChecked: isAllChecked,
            // close menu
            menuIsOpen: false,
        });

        if(this.props.onDoneClick)
            this.props.onDoneClick({
                name: this.select.current.props.name,
                isAllChecked: this.state.isAllChecked,
                options: this.state.outOptions
            });
    }

    onCloseClick = (e) => {
        e.preventDefault();

        this.setState({
            outOptions: [],
            inOptions: [],
            isAllChecked: false,
            menuIsOpen: false,
        });
    }

    clearSelected = () => {
        this.setState({
            selectedOptions: [],
            selectedAllChecked: false,
        })
    }

    removeSelected = (index) => {

        var selectedOptions = this.state.selectedOptions.map((item, key) => {
            if(item.key == index)
                return { ...item, checked: false};
            else
                return { ...item};
        });

        this.setState({
            selectedOptions
        });
    }
}

export default SelectBase;